import { PolygonLayer } from "@deck.gl/layers";

import { DEFAULT_POLYGON_LAYER_PROPS } from "@/features/main-map/consts/map-draw-consts";

// World (or large) bounding box to cover everything; adjust if your coordinate system differs
const WORLD_BOUNDS: number[][] = [
  [-180, -90],
  [-180, 90],
  [180, 90],
  [180, -90],
];

function signedArea(ring: number[][]) {
  let sum = 0;
  for (let i = 0; i < ring.length; i++) {
    const [x1, y1] = ring[i];
    const [x2, y2] = ring[(i + 1) % ring.length];
    sum += (x2 - x1) * (y2 + y1);
  }
  return sum;
}

function orientRings(outer: number[][], hole: number[][]) {
  const outerCCW = signedArea(outer) > 0;
  const holeCCW = signedArea(hole) > 0;
  const orientedOuter = outerCCW ? outer : [...outer].reverse();
  const orientedHole = holeCCW ? [...hole].reverse() : hole;
  return { orientedOuter, orientedHole };
}

const getFlippedPolygonData = (polygon: number[][]) => {
  const { orientedOuter, orientedHole } = orientRings(WORLD_BOUNDS, polygon);

  return [[orientedOuter, orientedHole]];
};

export const getFlippedPolygonLayer = (polygon: number[][]) => {
  return new PolygonLayer({
    ...DEFAULT_POLYGON_LAYER_PROPS,
    id: "POLYGON-existing-polygon-mask-layer",
    data: getFlippedPolygonData(polygon),
    getPolygon: (d) => d,
    getFillColor: [245, 245, 245, 150],
  });
};
